import { render } from "./gtr-lifestyle-bonus.vue?vue&type=template&id=792ddc86&ts=true"
import script from "./gtr-lifestyle-bonus.vue?vue&type=script&lang=ts"
export * from "./gtr-lifestyle-bonus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__